import signImg from '../img/modals/sign.webp';
import logoBgIconSvg from '../img/logo-bg-icon.svg';
import iconsSvg from '../img/icons.svg';

class SubscriptionModal {
  constructor({ type = 1, content = '', onSuccess = null }) {
    this.type = type;
    this.content = content;
    this.onSuccess = onSuccess;
    this.modal = null;
    this._urls = {
      1: '/api/email',
      2: '/api/phone',
      3: '/api/email',
    };
    this._createModal();
  }

  _createModal() {
    this.modal = document.createElement('div');
    this.modal.className = 'subscription-modal';
    const lang = this._getLang();
    const placeholders = {
      en: [
        { type: 'email', placeholder: 'Your email address :', button: 'Contact us' },
        { type: 'tel', placeholder: 'Your phone number :', button: 'Request a consultation' },
        { type: 'email', placeholder: 'Your email address :', button: 'Contact us' },
      ],
      uk: [
        { type: 'email', placeholder: 'Ваша електронна пошта :', button: 'Зв’яжіться з нами' },
        { type: 'tel', placeholder: 'Ваш номер телефону :', button: 'Запросити консультацію' },
        { type: 'email', placeholder: 'Ваша електронна пошта :', button: 'Зв’яжіться з нами' },
      ],
    };
    const imageElem =
      this.type === 1 ? `<img src="${signImg}" alt="${lang === 'en' ? 'Road sign' : 'Дорожній знак'}" class="subscription-modal__image" />` : '';

    const typeIndex = [1, 2, 3].includes(this.type) ? this.type - 1 : 0;
    const ph = (placeholders[lang] || placeholders['en'])[typeIndex];
    this.modal.innerHTML = `
      <div class="subscription-modal__overlay"></div>
      <div class="subscription-modal__content type-${this.type}">
        <button class="subscription-modal__close" type="button">
          <svg width="24" height="24"><use xlink:href="${iconsSvg}#close-icon"></use></svg>
        </button>
        <div class="subscription-modal__body">
          <div class="subscription-modal__text">${this._getContent()}</div>
          <form class="subscription-modal__form">
            <input type="${ph.type}" name="${ph.type}" placeholder="${ph.placeholder}" autocomplete=off required />
            <button type="submit">${ph.button}</button>
          </form>
          ${imageElem}
        </div>
      </div>
    `;
    document.body.appendChild(this.modal);
    this._addEvents();
  }

  _getLang() {
    const html = document.documentElement;
    return html.lang || 'en';
  }

  _getContent() {
    const lang = this._getLang();
    const texts = {
      en: [
        '<span>If you are interested in our services</span> and would like to learn more, please contact us in the way most convenient for you.',
        '<span>Please leave</span> your phone number. Our manager will contact you within one hour.',
        '<span>Please leave</span> your email address, and we will respond within 24 hours.',
      ],
      uk: [
        `<span>Якщо вас зацікавили наші послуги</span> і ви бажаєте дізнатися більше — зв’яжіться з нами у зручний для вас спосіб.`,
        '<span>Будь ласка,</span> залиште свій номер телефону. Наш менеджер зв’яжеться з вами протягом години.',
        '<span>Залиште свою</span> електронну адресу, і ми відповімо вам протягом 24 годин.',
      ],
    };
    const typeIndex = [1, 2, 3].includes(this.type) ? this.type - 1 : 0;
    const langTexts = texts[lang] || texts['en'];
    return this.content || langTexts[typeIndex];
  }

  _addEvents() {
    this.modal.querySelector('.subscription-modal__close').onclick = () => this.close();
    this.modal.querySelector('.subscription-modal__overlay').onclick = () => this.close();

    this.modal.querySelector('.subscription-modal__form').onsubmit = e => {
      e.preventDefault();
      const input = e.target.querySelector('input');
      const value = input.value;
      this._submitForm(value);
    };

    const content = this.modal.querySelector('.subscription-modal__content');
    if (content) {
      content.addEventListener('click', e => {
        if (e.target === content) {
          this.close();
        }
      });
    }
  }

  _submitForm(value) {
    const GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSeApH4WN5Y7cITqaKCtzgjwYUOm1Lpah1piQifng56xqCE-ng/formResponse';
    const ENTRY_CONTACT = 'entry.82515864';
    const ENTRY_TYPE = 'entry.1209496458';

    const formData = new FormData();
    formData.append(ENTRY_CONTACT, value);
    formData.append(ENTRY_TYPE, this.type);

    fetch(GOOGLE_FORM_URL, {
      method: 'POST',
      body: formData,
    });

    this._showSuccess();
    if (typeof this.onSuccess === 'function') this.onSuccess();
  }

  _showSuccess() {
    const lang = this._getLang();
    const title = {
      en: 'Thank you!',
      uk: 'Дякуємо!',
    };
    const messages = {
      1: {
        en: 'Your email has been saved. We will get back to you within 24 hours.',
        uk: 'Вашу електронну адресу збережено. Ми відповімо вам протягом 24 годин.',
      },
      2: {
        en: 'Your phone number has been received. Our manager will contact you within one hour.',
        uk: 'Ваш номер отримано. Наш менеджер зв’яжеться з вами протягом години.',
      },
      3: {
        en: 'Your email has been saved. We will get back to you within 24 hours.',
        uk: 'Вашу електронну адресу збережено. Ми відповімо вам протягом 24 годин.',
      },
    };
    const body = this.modal.querySelector('.subscription-modal__body');
    body.innerHTML = `<div class="subscription-modal__success">
        <div class="modal__success__bg-wrapper">
          <img src="${logoBgIconSvg}" alt="${lang === 'en' ? 'Background logo' : 'Фоновий логотип'}" class="modal__success__bg type-${this.type}" />
        </div>

        <div class="subscription-modal__success-text">
          <h2 class="subscription-modal__success-title">${title?.[lang]}</h2>
          <p class="subscription-modal__success-message">${messages?.[this.type]?.[lang]}</p>
        </div>
        
        <button class="subscription-modal__success-close" type="button">
          <svg class="subscription-modal__icon" width="60" height="60">
            <use href="${iconsSvg}#success-icon"></use>
          </svg>
        </button>
      </div>`;

    const successCloseBtn = body.querySelector('.subscription-modal__success-close');
    if (successCloseBtn) {
      successCloseBtn.onclick = () => this.close();
    }
  }

  open() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    document.body.classList.add('modal-open');
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);

    this.modal.classList.add('open');
  }

  close() {
    this.modal.classList.remove('open');
    setTimeout(() => {
      if (this.modal) {
        this.modal.remove();
        this.modal = null;
        document.body.classList.remove('modal-open');
        document.documentElement.style.removeProperty('--scrollbar-width');
      }
    }, 300);
  }
}

export default SubscriptionModal;
